/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Content from "../../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import { Button, Block, Row, Col, } from "../../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../../layout/head/Head";
import ER2Update from "./ER2Update";
import OptionCDisable from "../../../components/DynmicOption/OptionCDisable.";

const ER2DataEdit = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [userData, setuserData] = useState("");
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const [Draft, setDraft] = useState(true);
    const [loading, setloading] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefIdER: 14,
    });
    const onInputChange = (e) => {  
        setFormData({ ...formData, [e.target.name]: e.target.value });
        /* //console.log(formData)*/
    };



    const getdata2 = async (emp) => {

        const sendData = {

            EmploymentId: Number(emp)
        }

        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/GetEr2param', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentRefIdER: Number(formData.EmploymentRefIdER),
            UserId: Number(localStorage.getItem("userId")),
        }

        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentIdEr)
                        getdata2(data.employmentIdEr)
                        setuserData(data)
                    }

                })


    };
    const generate = async () => {
        setloading(false)
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            EmploymentRefId: Number(formData.EmploymentRefIdER),
            YearId: Number(formData.year),
            MonthId: Number(formData.month),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/GenerateER2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    if (data === "Error") {
                        Swal.fire({
                            title: ' This Month Report is Already Submitted',
                            icon: 'error',

                        })
                    } else {
                        setloading(false)
                        getdata()
                    }

                })
    };


    useEffect(() => {

        setloading(true)
        getdata()

    }, [])
    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentIdEr: employmentId,
                }

                /* //console.log(sendData)*/
                await fetch(process.env.REACT_APP_API_LINK + 'api/ER/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/ERDashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };



    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata()
    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/ERDashboard")
        getdata()

    };

    const ADDDynamic = async () => {
        setloading(false)
        const sendData = {
            EmploymentId: employmentId,
            EmploymentRefId: Number(formData.EmploymentRefIdER),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/DynamicAddEr2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === 'Done') {
                        setloading(true)
                        getdata()
                    } else {
                        window.location.reload()
                    }

                })


    };

    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <Button onClick={() => window.location.href = '/ERDashboard'} color="dark">BACK</Button>
                        <Card className="card-bordered card-stretch" style={{ padding: 20 }}>

                            <h3 style={{ marginBottom: 40 }}>ER-II </h3>

                            {Draft ? <Row className="gy-4">
                                <Col md="6">
                                    <OptionCDisable catid="42" defaultValuemain={formData.year} onInputChange={onInputChange} namemain="year" mainid="year" />
                                </Col>
                                <Col md="6">
                                    <Button color="success" onClick={() => generate()} >Generate</Button>
                                </Col>
                            </Row> :
                                <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                    <Row className="gy-4">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Name of State: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Return related to Public/Private sector: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Statement Showing the Occupation-wise employment during the year: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                        <div className="table-responsive" style={{ height: window.innerHeight - 300, width: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>



                                            <table className="table" >

                                                <thead>
                                                    <tr >
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Sno
                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Name of Occupation/Occupation Code (NCO 2015)

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Education and Technical Education level

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            No. of employees

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Approximate number of vacancies in each occupation, likely to fill during the next calendar year due to retirement/ expansion or reorganisation.

                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Men

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Women

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total

                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {dataactive !== [] ? dataactive.map((details) =>


                                                        <ER2Update edit={true} value={details.value} name={details.name} er2detailsId={details.er2detailsId} employmentId={employmentId} ER2Update={ER2Update} />

                                                    ) : null}
                                                    <tr>
                                                        <Button color="success" onClick={() => ADDDynamic()}>ADD</Button>
                                                    </tr>

                                                </tbody>

                                            </table>

                                        </div>




                                    </div>
                                    <div style={{ marginTop: 30, marginRight: -10 }}>
                                        <Button color='info' onClick={() => onSaveDraft()}>Save As Draft</Button>  <Button onClick={onFormSubmit} color='success'>Submit</Button> <Button color='warning' onClick={() => onSaveDraftGoBack()}>Save As Draft And Back To Dashboard</Button>
                                    </div>
                                </Card>}



                        </Card>

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ER2DataEdit;
